export { default } from './TableHead';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableHead/index.js
// module id = 563
// module chunks = 2